import { useLocalSearchParams } from "expo-router";

import { PublishedCentralMemorialScreen } from "./[funeralHomeId]/[slug]";

const first = (value: string | string[] | undefined) =>
  Array.isArray(value) ? value[0] ?? "" : value ?? "";

/**
 * Canonical public memorial path: /memorial/<opaque-slug>.
 *
 * The nested funeral-home route remains a legacy compatibility path for old
 * invitations, but this screen never accepts a funeral-home or case id and
 * resolves the page through the server-owned global slug registry.
 */
export default function GlobalPublishedCentralMemorialScreen() {
  const params = useLocalSearchParams<{ slug?: string | string[] }>();
  return <PublishedCentralMemorialScreen globalSlug={first(params.slug)} />;
}
